import Users from './Users.gql';

export default Users;
